import React, { useEffect, useState } from 'react';
import { isNil, isNaN } from 'lodash';
import countdownHelper from '../help/countdown';

const Countdown = ({ countdownDate, text }) => {
    const [countDown, setCountDown] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    useEffect(() => {
        const targetDate = new Date(countdownDate);
        if (
            !isNil(targetDate) &&
            !isNaN(targetDate.getTime()) &&
            Date.now() < targetDate.getTime()
        ) {
            const interval = setInterval(() => {
                const c = countdownHelper.generateCountdown(targetDate);
                setCountDown(c);
            });

            return () => clearInterval(interval);
        }
    }, []);

    const generateText = () => {
        const r = new RegExp(/(\[\[\s*countdown\s*\]\])+/gi);
        return !text
            ? ''
            : text.replace(r, countdownHelper.generateCountdownText(countDown));
    };

    return <span dangerouslySetInnerHTML={{ __html: generateText() }} />;
};

export default Countdown;
